module.exports = __webpack_public_path__ + "static/media/private.e5ada141.png";